import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import './styles.css';
SwiperPage1.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
};

SwiperPage1.defaultProps = {
  id: '',
  isActive: false,
};

function SwiperPage1({ id, isActive }) {
  const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    if (isActive) {
      setAnimationClass('active'); // Khi active, chạy animation
    } else {
      setAnimationClass(''); // Nếu không active, reset
    }
  }, [isActive]);

  return (
    <div className={`hero-section hero-section-${id} ${animationClass}`}>
      <div className="hero-content">
        <h1>GamePiece Labs</h1>
        <h2>Phụ kiện Boardgame</h2>
        <p>Chuyên cung cấp các dịch vụ hỗ trợ Boardgame và In 3D</p>
        <a
          href="https://www.facebook.com/GamePieceLabs/"
          className="cta-link"
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noreferrer"
        >
          <button className="cta-button">Liên hệ ngay</button>
        </a>
      </div>
    </div>
  );
}

export default SwiperPage1;
